import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { Dialog, DialogTitle } from "./Dialog";
import { Button } from "./Button";
import { RiKey2Line } from "@remixicon/react";
import { fetchAdministrations } from "../services/ApiService";

export function ApiKeySetupModal() {
  const [open, setOpen] = useState(false);
  const [, setLocation] = useLocation();

  useEffect(() => {
    fetchAdministrations()
      .then((admins) => {
        if (!admins.some((a) => a.hasApiKey)) {
          setOpen(true);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <Dialog open={open} onClose={() => {}}>
      <div className="flex flex-col items-center text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-amber-50 ring-8 ring-amber-50/50">
          <RiKey2Line className="h-6 w-6 text-amber-600" />
        </div>

        <DialogTitle
          as="h3"
          className="mt-5 text-lg font-semibold text-gray-900"
        >
          API sleutel vereist
        </DialogTitle>

        <p className="mt-2 text-sm leading-relaxed text-gray-500">
          Er is nog geen Easyflex API sleutel geconfigureerd voor je
          administratie(s). Stel een API sleutel in om het portaal te kunnen
          gebruiken.
        </p>

        <Button
          color="primary"
          className="mt-6 w-full"
          onClick={() => {
            setOpen(false);
            setLocation("/administraties");
          }}
        >
          <RiKey2Line className="h-4 w-4" />
          API sleutel instellen
        </Button>
      </div>
    </Dialog>
  );
}
